import React from 'react';

export default class NoFound extends React.Component {
    render() {
        return (
          <div className="">
            <img style={{width: "30%",Height:"auto"}} src={process.env.PUBLIC_URL + '/images/404.jpg'} alt=' ' />
            <br />
            <h1>¡NO SE ENCUENTRA!</h1>
            <h5>La vacante ya no esta disponible</h5>
          </div>
        );
    }
}